<template>
    <div class='grid'>
        <DynamicImageContainer class="product-grid-image" :image='product.picture' @click='selectThumbnail'/>
        <DynamicImageContainer class="product-grid-image" :image='product.picture' @click='selectThumbnail'/>
        <DynamicImageContainer class="product-grid-image" :image='product.picture' @click='selectThumbnail'/>
    </div>
</template>

<script>
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";

export default {
    components: {DynamicImageContainer},
    props:['product'],
    emits:['thumbnailClickListener'],
    methods:{
        selectThumbnail(){
            this.$emit('thumbnailClickListener', this.image);
        }
    }
}
</script>

<style lang="scss" scoped>
.grid{
    display: grid;
    grid-template-columns: repeat(2, minmax(300px,1fr));
    gap: 20px;
}

.product-grid-image{
    width: 100%;

}
</style>